import React from "react";

export default function BreakApproverDialog({ open, onConfirm, onCancel, title, inputId }) {
  const dialogRef = React.useRef(null);
  const inputRef = React.useRef(null);
  const [approver, setApprover] = React.useState("");
  const confirmedRef = React.useRef(false);

  React.useEffect(() => {
    if (open) {
      setApprover("");
      confirmedRef.current = false;
      dialogRef.current?.showModal();
      inputRef.current?.focus();
    } else {
      dialogRef.current?.close();
    }
  }, [open]);

  const handleConfirm = () => {
    const name = approver.trim();
    if (name) {
      confirmedRef.current = true;
      onConfirm(name);
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className="missed-break-dialog"
      onClose={() => { if (!confirmedRef.current) onCancel(); }}
      onClick={(e) => { if (e.target === dialogRef.current) onCancel(); }}
    >
      <div className="missed-break-dialog-inner">
        <div className="notes-dialog-header">
          <h3 className="notes-dialog-title">{title}</h3>
          <button type="button" className="notes-dialog-close" aria-label="Cancel" onClick={onCancel}>×</button>
        </div>
        <label className="missed-break-dialog-label" htmlFor={inputId}>Approved By</label>
        <input
          ref={inputRef}
          id={inputId}
          type="text"
          className="missed-break-dialog-input"
          value={approver}
          onChange={(e) => setApprover(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && approver.trim()) handleConfirm(); }}
          placeholder="Enter approver name…"
        />
        <div className="missed-break-dialog-actions">
          <button type="button" className="missed-break-dialog-cancel" onClick={onCancel}>Cancel</button>
          <button type="button" className="missed-break-dialog-confirm" disabled={!approver.trim()} onClick={handleConfirm}>Confirm</button>
        </div>
      </div>
    </dialog>
  );
}
